// src/components/Footer.js
import React from 'react';
import { Globe } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const footerSections = {
    community: {
      title: '커뮤니티',
      links: [
        { label: '개발자 포럼', href: '#' },  
      ]
    },
    resources: {
      title: '리소스',
      links: [
        { label: '문서', href: '#' }, 
      ]
    },
    support: {
      title: '지원',
      links: [ 
        { label: 'FAQ', href: '#' }, 
      ]
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <Globe className="icon" />
              </div>
              <span className="logo-text">WorldLand</span>
            </div>
            <p className="footer-description">
              블록체인의 미래를 함께 만들어가는 글로벌 커뮤니티
            </p>
          </div>
          
          {Object.entries(footerSections).map(([key, section]) => (
            <div key={key} className="footer-section">
              <h3 className="section-title">{section.title}</h3>
              <ul className="section-links">
                {section.links.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="footer-link">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div> */}
        
        <div className="footer-bottom">
          <p className="copyright">
            &copy; 2025 WorldLand Blockchain Community. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;